import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AjaxService } from '../../../core/services/ajax.service';

@Injectable()
export class FinanceService {
    baseUrl: string = 'Finance.svc';
    constructor(private http: Http, private _ajaxService: AjaxService) {
    }
    
    // all(weekNumber, year, orderStatus, countryCode) {      
    //     return this._ajaxService.GET(this.baseUrl + "/all/" + weekNumber + "/" + year + "/" + orderStatus + "/" + countryCode); 
    // }

    allFinance(searchCriteria) {      
        return this._ajaxService.POST(this.baseUrl + "/allFinance", searchCriteria); 
    }

    selectShipper(fromWeekNumber, fromYear, toWeekNumber, toYear, orderStatus, shipper, countryCode) {      
        return this._ajaxService.GET(this.baseUrl + "/selectshipper/" + fromWeekNumber + "/" + fromYear + "/" + (toWeekNumber == '' ? '0' : toWeekNumber) + "/" + (toYear == '' ? '0': toYear) + "/" + orderStatus + "/" + shipper + "/" + countryCode); 
    }

    selectShippers() {      
        return this._ajaxService.GET(this.baseUrl + "/selectshippers"); 
    }

    exportToPdf(fromWeekNumber, fromYear, toWeekNumber, toYear, orderStatus, shipper, countryCode) {      
        return this._ajaxService.GET(this.baseUrl + "/exporttopdf/" + fromWeekNumber + "/" + fromYear + "/" + (toWeekNumber == '' ? '-1' : toWeekNumber) + "/" + (toYear == '' ? '-1': toYear) + "/" + orderStatus + "/" + shipper + "/" + countryCode); 
    }

    sendSfReport(fromWeekNumber, fromYear, toWeekNumber, toYear, orderStatus, shipper, countryCode) {      
        return this._ajaxService.GET(this.baseUrl + "/sendsfreport/" + fromWeekNumber + "/" + fromYear + "/" + (toWeekNumber == '' ? '-1' : toWeekNumber) + "/" + (toYear == '' ? '-1': toYear) + "/" + orderStatus + "/" + shipper + "/" + countryCode); 
    }
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/services/finance.service.ts